export const rugbyunion =
  'M189.77,240.5V179.25H194v-12.5H62v12.5h4.25V240.5H49.75V179.25H54V15.5h8V158.75H194V15.5h8V179.25h4.25V240.5H189.77Z'

export const RGU = rugbyunion
